import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import LanguageDetector from 'i18next-browser-languagedetector';

import common_en from './locales/en/common.json';
import common_es from './locales/es/common.json';

import admin_en from './locales/en/admin.json';
import admin_es from './locales/es/admin.json';

import studio_en from './locales/en/studio.json';
import studio_es from './locales/es/studio.json';

// don't want to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: 'en',
    debug: false,
    interpolation: { escapeValue: false },
    resources: {
      es: {
        common: common_es,
        admin: admin_es,
        studio: studio_es
      },
      en: {
        common: common_en,
        admin: admin_en,
        studio: studio_en
      }
    }
  });

export default i18n;
